module platform {
   export class CapabilityService {
      static $inject = ["$injector"];

      private _vscCapabilityService: CapabilityService;

      constructor(private $injector: any) {
      }

      get vscCapabilityService() {
         if (!this._vscCapabilityService) {
            this._vscCapabilityService =
                  this.$injector.get("vscCapabilityService");
         }
         return this._vscCapabilityService;
      }

      getCapability(serverGuid: string, capability: string): any {
         return this.vscCapabilityService.getCapability(serverGuid, capability);
      }
   }

   angular.module("com.vmware.platform.ui")
         .service("capabilityService", CapabilityService);
}
